import { useState, useMemo } from "react";
import { useNavigationLogs } from "../../hooks/logs/useNavigationLogs";

import styles from "../../styles/NavigationLogs.module.css";
import { Filters, FilterValues } from "./NavigationLogs/components/Filters";
import { GetNavigationLogsDto } from "./NavigationLogs/components/types";
import { MetricCards } from "./NavigationLogs/components/MetricCards";
import { LogsCharts } from "./NavigationLogs/components/LogsCharts";
import { LogsTable } from "./NavigationLogs/components/LogsTable";
import { LogDetailsModal } from "./NavigationLogs/components/LogDetailsModal";

export default function NavigationLogs() {
  const [filters, setFilters] = useState<FilterValues>({});
  const [selected, setSelected] = useState<GetNavigationLogsDto | null>(null);

  const { data, isLoading, refetch } = useNavigationLogs(filters);

  const logs: GetNavigationLogsDto[] = data?.items ?? [];

  const users = useMemo(() => {
    const seen = new Map<string, string>();
    logs.forEach((l) => {
      if (l.userId && l.fullname) seen.set(l.userId, l.fullname);
    });
    return Array.from(seen.entries()).map(([id, name]) => ({ id, name }));
  }, [logs]);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div>
          <h1 className={styles.title}>Logs de navegação</h1>
          <p className={styles.subtitle}>Actividade do sistema em tempo real</p>
        </div>
        <button
          type="button"
          className={styles.refreshBtn}
          onClick={() => refetch()}
          disabled={isLoading}
        >
          <RefreshIcon />
          Actualizar
        </button>
      </div>

      <Filters onChange={setFilters} users={users} />

      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <>
          <MetricCards logs={logs} />
          <LogsCharts logs={logs} />
          <LogsTable logs={logs} onSelect={setSelected} />
        </>
      )}

      <LogDetailsModal
        log={selected}
        open={!!selected}
        onClose={() => setSelected(null)}
      />
    </div>
  );
}

function RefreshIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true" focusable="false">
      <path d="M11 6.5A4.5 4.5 0 1 1 6.5 2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M11 2v3H8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function LoadingSkeleton() {
  return (
    <div className={styles.skeleton}>
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className={styles.skeletonRow} style={{ opacity: 1 - i * 0.12 }} />
      ))}
    </div>
  );
}
